import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
    selector: 'nav-toggle-button',
    templateUrl: './nav-toggle-button.component.html',
    styleUrls: ['./nav-toggle-button.component.scss'],
})
export class NavToggleButtonComponent implements OnInit {
    constructor() {}

    @Output() navWidthOutput: EventEmitter<number> = new EventEmitter<number>();
    navWidth = 56;
    smallMenu = true;

    ngOnInit(): void {}

    changeNavWidth() {
        this.smallMenu = !this.smallMenu;
        this.setSideNavWidth();
        this.navWidthOutput.emit(this.navWidth);
    }

    setSideNavWidth() {
        let navWidth = 56;
        if (!this.smallMenu) {
            navWidth = 248;
        }
        this.navWidth = navWidth;
    }
}
